<style>
</style>

<template>
    <div>
        <Request
                ref="request"
                method="GET"
                :onRequestSuccess="onSuccess"
                :root="root">
            <slot slot="body">
                <b-form-group
                        :description="description"
                        :label="label"
                        :label-for="id"
                        :label-cols="labelCols">
                    <b-input-group class="input-group-sm">
                        <b-form-input
                                v-model="dataCode"
                                :placeholder="placeHolder"
                                type="text">
                        </b-form-input>
                        <b-input-group-append
                                @click="onValidateClick">
                            <b-input-group-text>
                                <i v-if="dataProcessing===true" class="fa fa-spinner fa-spin"></i>
                                <i v-if="dataProcessing===false" class="fa fa-check"></i>
                            </b-input-group-text>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
            </slot>
        </Request>
    </div>
</template>

<script>
    import Request from './Request'
    export default {
        name: 'InputPromoCode',
        components: {
            Request
        },
        props: {
            id: {
                type: String,
                default: ''
            },
            value: {
                type: Object,
                default: function () {
                    return {}
                }
            },
            label: {
                type: String,
                default: ''
            },
            description: {
                type: String,
                default: ''
            },
            labelCols: {
                type: Number,
                default: 0
            },
            placeHolder: {
                type: String,
                default: ''
            },
            root: {
                type: String,
                default: '',
                required:true
            },
            form: {
                type: Object,
                default: function () {
                    return {}
                }
            }
        },
        watch: {
            value(val) {
                this.dataValue = val
            },
            dataValue(val) {
                this.$emit('input', val)
                this.$emit('change', this.dataValue)
            }
        },
        mounted() {
            this.dataValue = {
                code: '',
                isValid: false,
                instance: {}
            }
        },
        data: () => {
            return {
                dataValue: {},
                dataCode: '',
                dataProcessing: false
            }
        },
        methods: {
            onValidateClick() {
                this.dataProcessing = true
                this.$refs.request.clearArgs()
                this.$refs.request.addArg('code', this.dataCode)
                this.$refs.request.request()
            },
            onSuccess(data) {
                if (data.promoCode !== undefined) {
                    this.dataValue = data.promoCode
                }
                this.dataProcessing = false
            }
        }
    }
</script>